import axios from "@axios";

export default {
  namespaced: true,
  state: {
    devices: []
  },
  getters: {},
  mutations: {},
  actions: {

    async getAll(_, params) {
      const response = await axios.get("v1/ai-analytics/devices", {
        params,
      });

      return response.data;
    },

    async add(_, params) {
      const { data } = await axios.post("v1/ai-analytics/servers/devices", params);

      return data;
    },

    async delete(_, params) {
      const { data } = await axios.delete("v1/ai-analytics/servers/devices", { data: params });

      return data;
    },

    async updateStatus(_, params) {
      const { data } = await axios.post("v1/ai-analytics/servers/update-device-status", params);

      return data;
    },

    async restartServer(_, uuid) {
      const { data } = await axios.post(`v1/ai-analytics/restart-server/${uuid}`);

      return data;
    },
  }
};
